import number from '../number'

export default function (value: number, precise = 0) {
  return number(value, '', precise, ' 天')
}
